import { useState, useEffect, useRef, RefObject } from 'react';

const useLazyLoad = (offset: number = 0): [RefObject<HTMLDivElement>, boolean] => {
  const [isIntersecting, setIntersecting] = useState<boolean>(false);
  const [hasIntersected, setHasIntersected] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!hasIntersected) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIntersecting(true);
            setHasIntersected(true); // Đánh dấu là đã gặp phần tử
            observer.unobserve(entry.target); // Dừng theo dõi sau khi gặp
          }
        },
        {
          rootMargin: `${offset}px`
        }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }
  }, [offset, hasIntersected]);

  return [ref, isIntersecting];
};

export default useLazyLoad;
